// Mapping rules shared by the upload screen and the reprocess dialog.
// A sheet mapping is { excel column: field }, as saved in processor_mappings.config.

export const NO_SHEET_ERROR = "Aucune feuille n'est configurée pour le traitement";

// The required fields and at least one important field must be mapped on every processed sheet
export const sheetMappingErrors = (sheet, mapping, choices) => {
  const fields = Object.values(mapping);
  const errors = choices
    .filter((c) => c.required && !fields.includes(c.value))
    .map((c) => `Feuille "${sheet}": Le champ requis "${c.description}" n'est pas mappé`);
  const important = choices.filter((c) => c.important && !c.required);
  if (important.length > 0 && !important.some((c) => fields.includes(c.value))) {
    errors.push(`Feuille "${sheet}": Au moins un champ important doit être mappé`);
  }
  return errors;
};

// First distinct non-empty values of a column, from the sample rows of the file
export const sampleValues = (sampleRows, column, max = 3) => {
  const values = [];
  (sampleRows || []).forEach((row) => {
    const value = row[column];
    if (value === null || value === undefined || value === '') return;
    const text = String(value);
    if (!values.includes(text) && values.length < max) values.push(text);
  });
  return values;
};

// The filter fields keep only the rows of the load's week or year: their raw file values
// (Week 31, Week 32...) look wrong in a preview without saying which one is kept
export const filterNote = (field, period) => {
  if (!period?.year || !period?.week) return null;
  const week = String(period.week).padStart(2, '0');
  if (field === 'week_filter') return `garde la semaine ${period.week}`;
  if (field === 'year_filter') return `garde l'année ${period.year}`;
  if (field === 'year_week_filter') return `garde ${period.year}${week}`;
  return null;
};
